import { render, staticRenderFns } from "./ToggleSwitchOff.vue?vue&type=template&id=134175c4"
import script from "./ToggleSwitchOff.vue?vue&type=script&lang=js"
export * from "./ToggleSwitchOff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports